import analytics from 'common/analytics';
import { getErrorMessage } from 'application/util/error.util';

import './settings.style.sass';
import template from './settings.tpl.pug';

class SettingsController {
    /* @ngInject */
    constructor($state, sessionService, navigationService, notificationService) {
        this.$state = $state;
        this.sessionService = sessionService;
        this.navigationService = navigationService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.closeNavigation();
        this.plan = this.plan || {};
        this.loadPlan();
    }

    loadPlan() {
        return this.sessionService.initialize().then((data) => {
            this.plan = data.plan || this.plan;
        }).catch(() => null);
    }

    openNavigation() {
        this.isNavigationVisible = true;
    }

    closeNavigation() {
        this.isNavigationVisible = false;
    }

    signOut() {
        if (this.signingOut) {
            return null;
        }

        this.signingOut = true;

        return this.sessionService.signOut()
            .then(() => {
                this.$state.go('identity.sign-in');

                analytics.trackSessionEnd('User', true);
            })
            .catch((result) => {
                this.notificationService.showError(getErrorMessage(result, `We were not able to log you out. Please try again later.`));
                return null;
            })
            .finally(() => {
                this.signingOut = false;
            });
    }

    goBack() {
        this.$state.go('authorized.calendar');
    }
}

export default {
    selector: 'dbASettings',
    template: template(),
    controller: SettingsController,
    bindings: {
        plan: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/settings.cmpt.js